<template>
    <div class="p-8 rounded-lg text-xs bg-[#FFF6BE] border-l-4 border-[#FFB12D] relative text-neutral-500 mb-6">
        <div class="bg-white rounded-full h-10 w-10 absolute -top-4 -left-4 flex items-center justify-center">
            <i class="fa-triangle-exclamation text-2xl fa-light text-[#FFB12D]"></i>
        </div>
        <slot></slot>
    </div>
</template>
<script lang="ts" setup></script>
